import {Text, TextPriority, TextTypography} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useWidgetState} from '../../../hooks/state-provider'
import {getActiveCategoryName} from '../../../selectors/categories'
import {classes} from './empty-category.st.css'

export const EmptyCategory = () => {
  const {t} = useTranslation()
  const categoryName = useWidgetState(state => getActiveCategoryName(state, t))

  return (
    <div className={classes.root}>
      <Text
        tagName="h2"
        typography={TextTypography.smallTitle}
        priority={TextPriority.primary}
        className={classes.titleText}
      >
        {t('categoryEmptyState_noEvents', {categoryName})}
      </Text>
      <div className={classes.subtitlePosition}>
        <Text priority={TextPriority.secondary} className={classes.subtitleText}>
          {t('categoryEmptyState_tryAnother')}
        </Text>
      </div>
    </div>
  )
}
